import { marked } from 'marked';
import { indigo } from 'tailwindcss/colors';

export default new (class {
  getObjects(obj, key, val) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) continue;
      if (typeof obj[i] === 'object') {
        objects = objects.concat(this.getObjects(obj[i], key, val));
      }
      //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
      else if ((i === key && obj[i] === val) || (i === key && val === '')) {
        //
        objects.push(obj);
      } else if (obj[i] === val && key === '') {
        //only add if the object is not already in the array
        if (objects.lastIndexOf(obj) === -1) {
          objects.push(obj);
        }
      }
    }
    return objects;
  }

  getPlainText(body) {
    const lexer = marked.lexer(body);
    let tempText = '';
    for (const lexitem of lexer) {
      const find = this.getObjects(lexitem, 'type', 'text');
      if (find.length && find[0].text) {
        if (!find[0].text.includes('http')) {
          find[0].text = find[0].text.replace(/&amp;/g, '&');
          find[0].text = find[0].text.replace(/&#39;/g, "'");
          find[0].text = find[0].text.replace(/&quot;/g, '"');
          tempText += find[0].text;
        }
      }
    }
    return tempText;
  }

  getHtmlText(body) {
    const renderer = {
      heading(text, level) {
        let className = 'text-xl';
        switch (level) {
          case 1:
            className = 'text-3xl';
            break;
          case 2:
            className = 'text-2xl';
            break;
          case 3:
            className = 'text-xl';
            break;
          case 4:
            className = 'text-lg';
            break;
          case 5:
            className = 'text-lg';
            break;
          case 6:
            className = 'text-lg';
            break;
          default:
            className = 'text-lg';
            break;
        }

        // console.log(text, level);
        return `<h${level} class="mt-6 font-semibold ${className}">${text}</h${level}>`;
      },

      paragraph(text) {
        //text = text.replace('\n', '<br>');

        return `<p class="text-2lg mt-3">${text}</p>`;
      },

      listitem(text, task, checked) {
        console.log(text, task, checked);
        // text = text.replace(' ', '&nbsp;&nbsp;&nbsp;&nbsp;');

        return `<li class="ml-5 mt-3 text-lg whitespace-pre-line list-disc">${text}</li>`;
      },

      html(html) {
        if (html.includes('<center>') || html.includes('<Center>')) {
          let newHtml = html.replace('<center>', '');
          newHtml = newHtml.replace('</center>', '');
          newHtml = newHtml.replace('<Center>', '');
          newHtml = newHtml.replace('</Center>', '');
          // console.log(newHtml);
          return marked.parse(newHtml);
        } else if (html.includes('http')) {
          if (html.includes('.JPG')) {
            html = html.replace(/http/gi, `<img src="http`);
            html = html.replace(/.JPG/gi, `.JPG"/>`);
          } else if (html.includes('.jpg')) {
            html = html.replace(/http/gi, `<img src="http`);
            html = html.replace(/.jpg/gi, `.jpg"/>`);
          } else if (html.includes('.png')) {
            html = html.replace(/http/gi, `<img src="http`);
            html = html.replace(/.png/gi, `.png"/>`);
          } else if (html.includes('.jpeg')) {
            html = html.replace(/http/gi, `<img src="http`);
            html = html.replace(/.jpeg/gi, `.jpeg"/>`);
          }
        }
        return `<p>${html}</p>`;
      },

      link(href, title, text) {
        // console.log(href, title, text);

        if (href.includes('webp')) {
          return `<img src="${href}"></img>`;
        } else if (
          href.includes('.png') ||
          href.includes('.jpg') ||
          href.includes('.jpeg') ||
          href.includes('.JPG')
        ) {
          return `<img src="${href}"></img>`;
        } else if (href.includes('.gif')) {
          return `<img src="${href}"></img>`;
        } else {
          return `<a class="text-blue-500 break-all" href="${href}">${href}</a>`;
        }
      },
      // image(href, title, text) {
      //   console.log(href, title, text);
      //   return `<img class="object-scale-down" src="${href}"></img>`;
      // },
      // object-scale-down
    };

    marked.use({ renderer });
    // const lexer = marked.lexer(body);
    // console.log(lexer);

    const parse = marked.parse(body);
    return parse;
  }
})();
